import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@nike/podium';
import { clsx } from 'clsx';
import { getBuildNumber } from '../../utils/buildNumber';
import { SidebarTrigger } from '~/components/shadcn/sidebar';
import { NikeSwoosh } from '@nike/nike-design-system-icons';
const LogoWrapper = ({ className }) => {
    return (_jsxs("nav", { className: clsx('z-10 flex w-fit items-center gap-3 px-4 header-height', className), draggable: false, children: [_jsx(NikeSwoosh, { size: "l" }), _jsx(Text, { font: "editorial-body-1-strong", children: "PULSE" }), _jsx(SidebarTrigger, {}), _jsx("div", { className: "ml-15", children: _jsx(Text, { font: "body-4", color: "var(--pds-color-gray-300)", children: getBuildNumber() }) })] }));
};
export default LogoWrapper;
